import { MessageUtil, FROM_TYPE } from 'Api/utils/Message.util';
import esignToolsPluginDocFns from './EsignToolsPluginDocFns.js';

export default class esignToolsController{
  constructor() {
    this.fnMap = {};
    this.windowMessageUtil = null;
    this.targetOrigin = `${window.location.origin}`;
    this.EsignToolsPluginDocFns = new esignToolsPluginDocFns(this.fnMap);
    this.origin = window.location.origin;
    this.onRequestCallback = this.onRequestCallback.bind(this);
  }

  async init() {
    if(this.isInit){
      return 
    };
    
    this.windowMessageUtil = new MessageUtil();

    this.windowMessageUtil.init(this.onRequestCallback, FROM_TYPE.ONLINE, this.targetOrigin);

    this.EsignToolsPluginDocFns.registerFn();
    //let origin = baseUrlApis.getBaseOrigin();
   
    this.isInit = true;
   
  }
  openEsignTools(){
    const targetOrigin = `${this.origin}/internal_identity_verify?origin=${this.origin}`;
    window.open(targetOrigin, 'esignTools');
  
    this.init();
  }

  onRequestCallback(method, data, id, listener){
    return new Promise((resolve)=>{
      const fn = this.fnMap[method];
      if(!fn){
        return
      }
      fn({method, data, id, listener, resolve});
    })
  }
}